import { useMemo } from 'react';
import FAQTopic from './Topic';
import useTranslation from 'next-translate/useTranslation';
import { FAQTopic as FAQTopicProps } from './Topic/props';
import styles from './styles.module.scss';

export default function TopicList() {
  const { t } = useTranslation('affiliates');
  const faq: Record<string, FAQTopicProps> = t(
    'faq',
    { app_provider: process.env.NEXT_PUBLIC_BET_NAME },
    {
      returnObjects: true,
    },
  );

  const Topics = useMemo(
    () =>
      Object.values(faq).map((faqTopic, i) => (
        <FAQTopic key={`faq_topic_${i}`} index={i} {...faqTopic} />
      )),
    [faq],
  );

  return <div className={styles.container}>{Topics}</div>;
}
